import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

interface DeleteEndpointConfirm {
  entity: string;
  name: string;
  type?: string;
}

@Component({
  selector: 'app-delete-endpoint-confirm',
  templateUrl: './delete-endpoint-confirm.component.html',
  styleUrls: ['./delete-endpoint-confirm.component.scss'],
  standalone: false
})
export class DeleteEndpointConfirmComponent {
  public data = inject(NZ_MODAL_DATA) as DeleteEndpointConfirm;

  constructor(
    private dialogRef: NzModalRef<DeleteEndpointConfirmComponent>,
  ) { }

  confirmClicked(value: boolean) {
    this.dialogRef.close(value);
  }

  closeDialog(value: boolean): void {
    this.dialogRef.close(value);
  }
}
